export default "__VITE_ASSET__is5qCYr7__"